module.exports = __webpack_public_path__ + "img/excel.7aa5f2e9.png";